import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SharpAudioService {
  private ctx: AudioContext | null = null;

  private ensureCtx(): AudioContext | null {
    try {
      if (!this.ctx) {
        const Ctor: typeof AudioContext =
          (window as any).AudioContext || (window as any).webkitAudioContext;
        if (!Ctor) return null;
        this.ctx = new Ctor();
      }
      if (this.ctx.state === 'suspended') this.ctx.resume();
      return this.ctx;
    } catch {
      return null;
    }
  }

  prime(): void {
    this.ensureCtx();
  }

  tone(freq: number, dur: number, type: OscillatorType = 'sine', vol = 0.08): void {
    const c = this.ensureCtx();
    if (!c) return;
    try {
      const o = c.createOscillator();
      const g = c.createGain();
      o.type = type;
      o.frequency.value = freq;
      g.gain.setValueAtTime(vol, c.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + dur);
      o.connect(g);
      g.connect(c.destination);
      o.start();
      o.stop(c.currentTime + dur);
    } catch {}
  }

  hit(): void {
    this.tone(880, 0.08, 'sine', 0.08);
    setTimeout(() => this.tone(1108, 0.06, 'sine', 0.05), 50);
  }

  miss(): void {
    this.tone(330, 0.15, 'triangle', 0.06);
    setTimeout(() => this.tone(220, 0.1, 'triangle', 0.04), 80);
  }

  word(): void {
    this.tone(659, 0.05, 'triangle', 0.05);
  }

  success(): void {
    this.tone(523, 0.08, 'sine', 0.08);
    setTimeout(() => this.tone(659, 0.08, 'sine', 0.08), 80);
    setTimeout(() => this.tone(784, 0.1, 'sine', 0.08), 160);
    setTimeout(() => this.tone(1047, 0.12, 'sine', 0.08), 240);
  }

  tick(): void {
    this.tone(660, 0.03, 'sine', 0.04);
  }

  padTone(digit: number): void {
    const freqs = [0, 523, 587, 659, 784, 880, 1047, 1175, 1319, 1568];
    this.tone(freqs[digit] || 523, 0.2, 'sine', 0.07);
  }
}
